import {makeStyles, Theme, createStyles} from '@material-ui/core/styles';

export const useSubmitCancelFormStyles = makeStyles((theme: Theme) =>
    createStyles({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            display: 'flex',
            flexDirection: 'column',
            outline: 'none',
            backgroundColor: theme.palette.background.paper,
            border: '4px solid #4c4c4c',
            boxShadow: theme.shadows[5],
            // width: '40vw',
            minWidth: '500px',
            // maxWidth: '900px',
            maxWidth: '99vw',
            maxHeight: '87vh',
        },
        title: {
            backgroundColor: '#eaebec',
            padding: '20px 0',
            textAlign: 'center',
            whiteSpace: 'pre-line',
        },
        body: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
            padding: theme.spacing(2, 4, 3),
        },
        footer: {
            height: '60px',
            display: "flex",
            flexGrow: 1,
            flexDirection: "column",
        },
        footerButtons: {
            '& > *': {
                margin: theme.spacing(2, 4),
            },
            display: 'flex',
            height: '100%',
            justifyContent: "space-between",
            alignItems: "center",
        },
        closeButton: {
            color: 'white',
            width: '200px',
            backgroundColor: '#869098'
        },
        cancelButton: {
            color: 'white',
            width: '200px',
            backgroundColor: '#E31F0B'
        },
        addButton: {
            color: 'white',
            width: '200px',
            backgroundColor: '#303844'
        }
    }),
);